import { render, staticRenderFns } from "./AddSteps.vue?vue&type=template&id=0bb37f8f&scoped=true"
import script from "./AddSteps.vue?vue&type=script&lang=js"
export * from "./AddSteps.vue?vue&type=script&lang=js"
import style0 from "./AddSteps.vue?vue&type=style&index=0&id=0bb37f8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb37f8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
